var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-address c-address--saved u-margin-bottom-small" },
    [
      !_vm.active
        ? _c("div", { staticClass: "c-address__info" }, [_vm._t("info")], 2)
        : _c(
            "div",
            { staticClass: "c-address__form u-margin-bottom-small" },
            [_vm._t("form")],
            2
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }